// modules
import { createSelector } from 'reselect'
import { get, sortBy } from 'lodash'

// constants
import { OTHER_DROPDOWN_VALUE } from 'src/constants'

const medicalDeviceOrdering$ = (state = {}) =>
  get(state, ['actions', 'medicalDeviceOrdering'], [])

export const medicalDeviceOrderingList$ = createSelector(
  medicalDeviceOrdering$,
  (medicalDeviceOrdering = {}) => get(medicalDeviceOrdering, ['orderList'], [])
)

export const medicalDeviceOrderingEditOrder$ = createSelector(
  medicalDeviceOrdering$,
  (medicalDeviceOrdering = {}) => get(medicalDeviceOrdering, ['editOrder'], {})
)

export const medicalDeviceOrderingPatientAddresses$ = createSelector(
  medicalDeviceOrdering$,
  (medicalDeviceOrdering = {}) =>
    get(medicalDeviceOrdering, ['patientAddresses'], [])
)

export const medicalDeviceOrderingPatientAddressesDropdown$ = createSelector(
  medicalDeviceOrderingPatientAddresses$,
  (patientAddresses = []) => {
    const mappedAddresses = patientAddresses.map(
      ({ uuid, address, city, state, zip }) => ({
        key: uuid,
        value: uuid,
        title: `${address}, ${city}, ${state}, ${zip}`,
        address,
        state,
        city,
        zip
      })
    )

    mappedAddresses.push(OTHER_DROPDOWN_VALUE)

    return mappedAddresses
  }
)

export const medicalDeviceOrderingPatientProfile$ = createSelector(
  medicalDeviceOrdering$,
  (medicalDeviceOrdering = {}) =>
    get(medicalDeviceOrdering, ['patientProfile'], {})
)

export const medicalDeviceOrderingTypeList$ = createSelector(
  medicalDeviceOrdering$,
  (medicalDeviceOrdering = {}) => get(medicalDeviceOrdering, ['typeList'], {})
)

export const medicalDeviceOrderingTypeListDropdown$ = createSelector(
  medicalDeviceOrderingTypeList$,
  (typeList = []) =>
    sortBy(
      typeList.map((item) => ({
        key: item.uuid,
        title: item.name,
        value: item.uuid,
        isActive: item.isActive,
        disabled: !item.isActive,
        isIntegrationIdRequired: item.isIntegrationIdRequired
      })),
      'orderNumber'
    )
)
